export function useGtInsightImages(): boolean {
  return process.env.VUE_APP_BRAND === 'GT';
}

/** Image paths used by ContentTree (gt-library / go_beyond). */
export const CONTENT_TREE_IMAGES: string[] = [
  'gt/image/go_beyond/001.jpg',
  'gt/image/go_beyond/002.jpg',
  'gt/image/go_beyond/003.jpg',
  'gt/image/go_beyond/005.jpg',
  'gt/image/go_beyond/007.jpg',
  'gt/image/go_beyond/009.jpg',
  'gt/image/go_beyond/011.jpg',
  'gt/image/go_beyond/013.jpg',
  'gt/image/go_beyond/015.jpg',
  'gt/image/go_beyond/017.jpg',
  'gt/image/go_beyond/019.jpg',
  'gt/image/go_beyond/021.jpg',
  'gt/image/go_beyond/023.jpg',
  'gt/image/go_beyond/025.jpg',
  'gt/image/go_beyond/027.jpg',
  'gt/image/go_beyond/029.jpg',
  'gt/image/go_beyond/031.jpg',
  'gt/image/go_beyond/033.jpg',
];

function hashKey(key: string): number {
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = (hash * 31 + key.charCodeAt(i)) % 2147483647;
  }
  return hash < 0 ? -hash : hash;
}

/** Pick a stable ContentTree image for an insight key (id/category/question). */
export function imageForInsight(key: string): string {
  if (!useGtInsightImages()) {
    return '';
  }
  if (!key) {
    return CONTENT_TREE_IMAGES[0];
  }
  return CONTENT_TREE_IMAGES[hashKey(key) % CONTENT_TREE_IMAGES.length];
}

/**
 * Assign images for a set of insights so each gets a distinct path when possible.
 * Prefers an existing image when it is still unused; otherwise falls back to the
 * hashed pick and then walks the pool.
 */
export function assignUniqueInsightImages(
  keys: string[],
  preferred: Array<string | undefined | null> = [],
): string[] {
  if (!useGtInsightImages()) {
    return keys.map(() => '');
  }
  const used = new Set<string>();
  const result: string[] = [];

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i] || String(i);
    const candidates: string[] = [];
    const pref = preferred[i];
    if (pref && CONTENT_TREE_IMAGES.indexOf(pref) >= 0) {
      candidates.push(pref);
    }
    const hashed = imageForInsight(key);
    if (candidates.indexOf(hashed) < 0) {
      candidates.push(hashed);
    }
    const start = hashKey(key) % CONTENT_TREE_IMAGES.length;
    for (let offset = 0; offset < CONTENT_TREE_IMAGES.length; offset++) {
      const img =
        CONTENT_TREE_IMAGES[(start + offset) % CONTENT_TREE_IMAGES.length];
      if (candidates.indexOf(img) < 0) {
        candidates.push(img);
      }
    }

    let chosen = candidates[0] || CONTENT_TREE_IMAGES[0];
    for (const candidate of candidates) {
      if (!used.has(candidate)) {
        chosen = candidate;
        break;
      }
    }
    used.add(chosen);
    result.push(chosen);
  }

  return result;
}

export function staticImageUrl(imagePath: string): string {
  if (!imagePath) {
    return '';
  }
  return `/static/${imagePath}`;
}
